import type { ScenarioId } from '@finsim/model';
import { createEvent, createStore } from 'effector';
import { projectClosed } from '../../entities/project';

/** Month being explained (click on a chart); null when the explain dialog is closed. */
export const explainOpened = createEvent<{ scenarioId: ScenarioId; index: number }>();
export const explainClosed = createEvent();
export const $explain = createStore<{ scenarioId: ScenarioId; index: number } | null>(null)
  .on(explainOpened, (_, target) => target)
  .reset(explainClosed, projectClosed);
